// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** UPDATE AADHAR START *********************** */
export const aadharUpdateDetails = (updateAadharData: any) => {
	const data = {
		AadharDetailsToken: updateAadharData,
	};
	const url = `${API_URL}updateAadharDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE AADHAR END *********************** */

/** ***************** AADHAR OTP START *********************** */
export const memberAaharOtp = (addData: any) => {
	const data = {
		verifyAadharOtpToken: addData,
	};
	const url = `${API_URL}VerifyAadharWithOtp`;
	return makeApiCall(url, data);
};
/** ***************** AADHAR OTP END *********************** */
